import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { Badge, Button, Drawer } from "antd";
import { cloneDeep, forEach } from "lodash";
import React, { FC, useEffect, useState } from "react";
import FilterForDayCalender from "../FilterForDayCalender/filterForDayCalender";

import "./dayFilter.scss";

const DayFilter: FC<any> = () => {
  const layerViews = [
    {
      label: "Filters:",
      key: "filter",
      width: "300",
      padding: 0,
      className: "filtersDrawer",
    },
  ];

  //filters
  const setOfficeNameToStore = useCalenderViewStore((state) => state.setOfficeName);
  const officeNameToStore = useCalenderViewStore((state) => state.officeName);
  const setDayFilter = useCalenderViewStore((state) => state.setDayFilter);
  const dayFilter = useCalenderViewStore((state) => state.dayFilter);
  const setOfficeIdToStore = useCalenderViewStore((state) => state.setOfficeId);
  const officeIdToStore = useCalenderViewStore((state) => state.officeId);

  const [copyTempDayFilter, setCopyTepDayFilter] = useState(cloneDeep(dayFilter));

  const setIsFilterDayApplied = useCalenderViewStore((state) => state.setIsFilterDayApplied);
  const isFilterDayApplied = useCalenderViewStore((state) => state.isFilterDayApplied);
  const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);
  const setApplyFilterFlag = useCalenderViewStore((state) => state.setApplyFilterFlag);
  const selectedActiveDayFilters = useCalenderViewStore((state) => state.selectedActiveDayFilters);
  const setSelectedActiveDayFilters = useCalenderViewStore((state) => state.setSelectedActiveDayFilters);

  const [isOpenDrawer, toggleDrawerHandler] = useState(false);
  const [isloadingFilter, setIsloadingFilter] = useState(false);

  const [masterFilterData, setMasterFilterData] = useState<any>([]);
  const [officeObject, setOfficeObject] = useState<any>({});
  const [copyOfficeObject, setCopyOfficeObject] = useState<any>({});
  const [officeId, setOfficeId] = useState(officeIdToStore);
  const [officeName, setOfficeName] = useState(officeNameToStore);
  const [masterFilterDataProviderType, setMasterFilterDataProviderType] = useState<any>([]);
  const [providerTypeObject, setProviderTypeObject] = useState<any>({});
  const [copyProviderTypeObject, setCopyProviderTypeObject] = useState<any>({});
  // const [activePanels, setActivePanels] = useState<any[]>(["office_name"]);

  // const [masterFilterDataProviderName, setMasterFilterDataProviderName] = useState<any>([]);
  const [providerNameObject, setProviderNameObject] = useState<any>({});
  const [copyProviderNameObject, setCopyProviderNameObject] = useState<any>({});

  // const [providerName, setProviderName] = useState({});

  const defaultOfficeNameFromEnv = `${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_NAME}`;
  // const [defaultOfficeNameFromEnv, setDefaultOfficeNameFromEnv] = useState(`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_NAME}`);
  // const [defaultOfficeIdFromEnv, setDefaultOfficeIdFromEnv] = useState(`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_ID}`);
  const defaultOfficeIdFromEnv = `${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_ID}`;
  useEffect(() => {
    console.log("DayFilter.useEffect");
    const getDayFilter = () => {
      console.log("DayFilter.getDayFilter");
      setIsloadingFilter(true);
      dashboardService.fetchCalenderViewDayFilterV2().subscribe({
        next: (v) => {
          setMasterFilterData(v.data.data.result);
          let tempOfficeList: any = [];
          forEach(v.data.data.result, (office) => {
            tempOfficeList.push(office.value);
          });
          let temp = tempOfficeList.filter((item: any) => {
            return officeName !== item;
          });
          if (officeName.length > 0) {
            temp = [officeName, ...temp];
          } else temp = cloneDeep(temp);
          tempOfficeList = temp;
          setOfficeObject({
            label: v.data.data.result.length > 0 ? v.data.data.result[0].label : "",
            column: v.data.data.result.length > 0 ? v.data.data.result[0].column : "",
            options: tempOfficeList,
            selectedOffice: officeNameToStore,
          });
          setCopyOfficeObject({
            label: v.data.data.result.length > 0 ? v.data.data.result[0].label : "",
            column: v.data.data.result.length > 0 ? v.data.data.result[0].column : "",
            options: tempOfficeList,
            selectedOffice: officeNameToStore,
          });
          ///populating ProviderType
          let tempMasterProviderType: any[] = [];
          if (officeNameToStore?.length > 0) {
            let tempProviderType: any = [];
            forEach(v.data.data.result, (office) => {
              if (office.value === officeNameToStore) {
                setOfficeId(office.officeId);
                setOfficeName(office.value);
                setMasterFilterDataProviderType(office.options);
                tempMasterProviderType = office.options;
              }
            });
            forEach(tempMasterProviderType, (providerType) => {
              tempProviderType.push(providerType.value);
            });
            let temp = tempProviderType.filter((item: any) => {
              return !dayFilter["provider_type"].includes(item);
            });
            temp = [...dayFilter["provider_type"], ...temp];
            tempProviderType = temp;
            setProviderTypeObject({
              label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
              column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
              options: tempProviderType,
              selectedOffice: [],
            });
            setCopyProviderTypeObject({
              label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
              column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
              options: tempProviderType,
              selectedOffice: [],
            });
          }
  
          let tempProviderName: any = [];
          forEach(tempMasterProviderType, (providerName) => {
            tempProviderName.push(...providerName.providers.values);
          });
          let tempInGroupingProviderName = tempProviderName.filter((item: any) => {
            return !dayFilter["provider_name"].includes(item);
          });
          tempInGroupingProviderName = [...dayFilter["provider_name"], ...tempInGroupingProviderName];
          tempProviderName = tempInGroupingProviderName;
          setProviderNameObject({
            label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
            column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
            options: tempProviderName,
            selectedOffice: [],
          });
          setCopyProviderNameObject({
            label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
            column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
            options: tempProviderName,
            selectedOffice: [],
          });
  
          setIsloadingFilter(false);
        },
        error: (e) => {
          console.log(e);
          setIsloadingFilter(false);
        },
      });
    };
    getDayFilter() 
  }, []);

  const onOfficeSelection = (selectedArray: any, selectedColumn: any) => {
    setProviderTypeObject({});
    setCopyProviderTypeObject({});
    setProviderNameObject({});
    setCopyProviderNameObject({});
    setCopyTepDayFilter({ provider_type: [], provider_name: [] });
    setSelectedActiveDayFilters(["office_name"]);

    // setDayFilter({ provider_type: [], provider_name: [] });

    let tempOfficeObject: any = cloneDeep(officeObject);
    if (selectedArray.length > 0)
      forEach(selectedArray, (office) => {
        if (!(officeObject.selectedOffice === office)) {
          tempOfficeObject.selectedOffice = office;
        }
      });
    else {
      tempOfficeObject.selectedOffice = "";
      // setDayFilter({ provider_type: [], provider_name: [] });
    }

    setOfficeObject(tempOfficeObject);
    let tempMasterProviderType: any[] = [];
    if (tempOfficeObject?.selectedOffice?.length > 0) {
      let tempProviderType: any = [];
      forEach(masterFilterData, (office) => {
        if (office.value === tempOfficeObject?.selectedOffice) {
          setOfficeId(office.officeId);
          setOfficeName(office.value);
          setMasterFilterDataProviderType(office.options);
          tempMasterProviderType = office.options;
        }
      });
      forEach(tempMasterProviderType, (providerType) => {
        tempProviderType.push(providerType.value);
      });
      setProviderTypeObject({
        label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
        column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
        options: tempProviderType,
        selectedOffice: [],
      });
      setCopyProviderTypeObject({
        label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
        column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
        options: tempProviderType,
        selectedOffice: [],
      });
    }

    let tempProviderName: any = [];
    forEach(tempMasterProviderType, (providerName) => {
      tempProviderName.push(...providerName.providers.values);
    });
    // let tempInGroupingProviderName = tempProviderName.filter((item: any) => {
    //   return !copyTempDayFilter["provider_name"].includes(item);
    // });
    // tempInGroupingProviderName = [...copyTempDayFilter["provider_name"], ...tempInGroupingProviderName];
    // tempProviderName = tempInGroupingProviderName;
    setProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });
    setCopyProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });
  };

  const onProviderTypeSelection = (selectedArray: any, selectedColumn: any) => {
    let tempProviderTypeObject: any = cloneDeep(providerTypeObject);
    let copyDayFilter = cloneDeep(copyTempDayFilter);
    let tempProviderName: any = [];
    let tempSelectionOfProviderName: any = [];
    if (selectedArray.length > 0) tempProviderTypeObject.selectedOffice = [...selectedArray];
    else {
      copyDayFilter = { provider_type: [], provider_name: copyDayFilter.provider_name };
    }
    copyDayFilter[selectedColumn] = [...selectedArray];
    if (selectedArray.length > 0) {
      forEach(masterFilterDataProviderType, (providerName) => {
        if (tempProviderTypeObject.selectedOffice.includes(providerName.value)) {
          tempProviderName.push(...providerName.providers.values);
          let temp = tempProviderName.filter((prName: any) => copyDayFilter["provider_name"].includes(prName));
          tempSelectionOfProviderName.push(...temp);
        }
      });
      copyDayFilter["provider_name"] = tempSelectionOfProviderName;
    }

    if (selectedArray.length === 0) {
      forEach(masterFilterDataProviderType, (providerName) => {
        tempProviderName.push(...providerName.providers.values);
        let temp = tempProviderName.filter((prName: any) => copyDayFilter["provider_name"].includes(prName));
        tempSelectionOfProviderName.push(...temp);
      });
      copyDayFilter["provider_name"] = tempSelectionOfProviderName;
    }
    setProviderNameObject({
      label: masterFilterDataProviderType.length > 0 ? masterFilterDataProviderType[0].providers.label : "",
      column: masterFilterDataProviderType.length > 0 ? masterFilterDataProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });
    setCopyProviderNameObject({
      label: masterFilterDataProviderType.length > 0 ? masterFilterDataProviderType[0].providers.label : "",
      column: masterFilterDataProviderType.length > 0 ? masterFilterDataProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });
    setProviderTypeObject(tempProviderTypeObject);
    // setDayFilter(copyDayFilter);
    setCopyTepDayFilter(copyDayFilter);
  };

  const onProviderNameSelection = (selectedArray: any, selectedColumn: any) => {
    let copyDayFilter = cloneDeep(copyTempDayFilter);
    let tempProviderNameObject: any = cloneDeep(providerNameObject);
    tempProviderNameObject.selectedOffice = [];
    let tempProviderName: any = [];
    let finalTempProviderName: any = [];

    if (selectedArray.length === 0) {
      tempProviderNameObject.selectedOffice = [];
      copyDayFilter["provider_name"] = [];
    }
    if (selectedArray.length > 0) {
      forEach(masterFilterDataProviderType, (providerName) => {
        if (copyDayFilter["provider_type"].length > 0) {
          if (copyDayFilter["provider_type"].includes(providerName.value)) {
            tempProviderName.push(...providerName.providers.values);
          }
        } else {
          tempProviderName.push(...providerName.providers.values);
        }
      });
      forEach(tempProviderName, (providerNameItem: any) => {
        if (selectedArray.includes(providerNameItem)) {
          finalTempProviderName.push(providerNameItem);
        }
      });
    }

    copyDayFilter["provider_name"] = finalTempProviderName;
    // setDayFilter(copyDayFilter);
    setCopyTepDayFilter(copyDayFilter);
  };

  const selectedPanels = (onAction:any) => {
    let tempSelectedActiveFilters:any = [];
    if(onAction==="onApply") tempSelectedActiveFilters = Object.keys(copyTempDayFilter).filter((filter:any) => copyTempDayFilter[filter].length > 0  );
    if(onAction==="onClose") tempSelectedActiveFilters = Object.keys(dayFilter).filter((filter:any) => dayFilter[filter].length > 0  );
    setSelectedActiveDayFilters([...tempSelectedActiveFilters, "office_name"]);
  };

  const onCollapseChange = (key:any) => {
    setSelectedActiveDayFilters([...key]);
  }

  const applyFilter = () => {
    if (!(officeObject.selectedOffice.length > 0)) {
      clearFilterHandler();
    } else {
      setOfficeNameToStore(officeName);
      setOfficeIdToStore(officeId);
    }
    setDayFilter(copyTempDayFilter);
    let flag = isFiltersApplied();
    flag ? setIsFilterDayApplied(true) : setIsFilterDayApplied(false);
    setApplyFilterFlag(!applyFilterFlag);
    selectedPanels("onApply");
    setCopyOfficeObject(officeObject);
    setCopyProviderTypeObject(providerTypeObject);
    setCopyProviderNameObject(providerNameObject);
    toggleDrawer();
  };

  const isFiltersApplied = () => {
    let presentFlag = false;
    forEach(Object.keys(copyTempDayFilter), (filterKeys) => {
      if (officeObject.selectedOffice.length > 0 && (copyTempDayFilter[filterKeys].length > 0 || officeObject.selectedOffice !== defaultOfficeNameFromEnv)) {
        presentFlag = true;
        return;
      }
    });
    if (presentFlag) return true;
    else return false;
  };

  const toggleDrawer = () => {
    toggleDrawerHandler(!isOpenDrawer);
  };

  const onCloseConfigDrawer = () => {
    let tempOfficeObject: any = cloneDeep(officeObject);
    tempOfficeObject.selectedOffice = officeNameToStore;
    // setOfficeName(officeNameToStore);
    // setOfficeId(officeIdToStore);
    setOfficeObject(tempOfficeObject);
    setCopyOfficeObject(tempOfficeObject);
    selectedPanels("onClose");

    /////////////////////////////

    let tempMasterProviderType: any[] = [];

    let tempProviderType: any = [];
    forEach(masterFilterData, (office) => {
      if (office.value === officeNameToStore) {
        setOfficeId(office.officeId);
        setOfficeName(office.value);
        setMasterFilterDataProviderType(office.options);
        tempMasterProviderType = office.options;
      }
    });
    forEach(tempMasterProviderType, (providerType) => {
      tempProviderType.push(providerType.value);
    });
    setProviderTypeObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
      options: tempProviderType,
      selectedOffice: [...dayFilter["provider_type"]],
    });
    setCopyProviderTypeObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
      options: tempProviderType,
      selectedOffice: [...dayFilter["provider_type"]],
    });

    let tempProviderName: any = [];
    forEach(tempMasterProviderType, (providerName) => {
      if (dayFilter["provider_type"].length > 0) {
        if (dayFilter["provider_type"].includes(providerName.value)) {
          tempProviderName.push(...providerName.providers.values);
        }
      } else {
        tempProviderName.push(...providerName.providers.values);
      }
    });
    let tempInGroupingProviderName = tempProviderName.filter((item: any) => {
      return !dayFilter["provider_name"].includes(item);
    });
    tempInGroupingProviderName = [...dayFilter["provider_name"], ...tempInGroupingProviderName];
    tempProviderName = tempInGroupingProviderName;
    setProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [...dayFilter["provider_name"]],
    });
    setCopyProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [...dayFilter["provider_name"]],
    });

    setCopyTepDayFilter(dayFilter);

    /////////////////////////////

    toggleDrawer();
  };

  const drawerFooter = () => {
    return (
      <div style={{ textAlign: "right" }} className="cancel-button">
        <Button type="text" size="large" onClick={onCloseConfigDrawer}>
          Cancel
        </Button>
        <Button type="primary" className="apply-filter" style={{ height: "40px" }} onClick={applyFilter}>
          Apply Filter
        </Button>
      </div>
    );
  };

  const drawerHeader = () => {
    return (
      <Button type="link" onClick={clearFilterHandler} className="clr-e100" style={{ fontWeight: "normal" }}>
        Clear All
      </Button>
    );
  };

  const onSearchOptionsOffice = (freeText: any) => {
    let filterObject = cloneDeep(officeObject);
    let temp = filterObject.options.filter((item: any) => {
      return officeName !== item && item.toLowerCase().includes(freeText.toLowerCase());
    });
    temp = [officeName, ...temp];
    filterObject.options = temp;
    setCopyOfficeObject(filterObject);
  };

  const onSearchOptionsProviderType = (freeText: any) => {
    let filterObject = cloneDeep(providerTypeObject);
    let temp = filterObject.options.filter((item: any) => {
      return !copyTempDayFilter["provider_type"].includes(item) && item.toLowerCase().includes(freeText.toLowerCase());
    });
    temp = [...copyTempDayFilter["provider_type"], ...temp];
    filterObject.options = temp;
    setCopyProviderTypeObject(filterObject);
  };

  const onSearchOptionsProviderName = (freeText: any) => {
    let filterObject = cloneDeep(providerNameObject);
    let temp = filterObject.options.filter((item: any) => {
      return !copyTempDayFilter["provider_name"].includes(item) && item.toLowerCase().includes(freeText.toLowerCase());
    });
    temp = [...copyTempDayFilter["provider_name"], ...temp];
    filterObject.options = temp;
    setCopyProviderNameObject(filterObject);
  };

  const clearFilterHandler = () => {
    setOfficeNameToStore(defaultOfficeNameFromEnv);
    setOfficeIdToStore(defaultOfficeIdFromEnv);
    setOfficeName(defaultOfficeNameFromEnv);
    setOfficeId(defaultOfficeIdFromEnv);
    let clearOfficeObject = cloneDeep(officeObject);
    let clearOfficeCopyObject = cloneDeep(copyOfficeObject);
    clearOfficeObject.selectedOffice = defaultOfficeNameFromEnv;
    clearOfficeCopyObject.selectedOffice = defaultOfficeNameFromEnv;
    setOfficeObject(clearOfficeObject);
    setCopyOfficeObject(clearOfficeCopyObject);
    // setDayFilter({ provider_type: [], provider_name: [] });
    setCopyTepDayFilter({ provider_type: [], provider_name: [] });
    setSelectedActiveDayFilters(["office_name"]);
    /////////////////////////////////////////////////////////////////////////////////////////////

    let tempMasterProviderType: any[] = [];

    let tempProviderType: any = [];
    forEach(masterFilterData, (office) => {
      if (office.value === defaultOfficeNameFromEnv) {
        setOfficeId(office.officeId);
        setOfficeName(office.value);
        setMasterFilterDataProviderType(office.options);
        tempMasterProviderType = office.options;
      }
    });
    forEach(tempMasterProviderType, (providerType) => {
      tempProviderType.push(providerType.value);
    });
    setProviderTypeObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
      options: tempProviderType,
      selectedOffice: [],
    });
    setCopyProviderTypeObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].column : "",
      options: tempProviderType,
      selectedOffice: [],
    });

    let tempProviderName: any = [];
    forEach(tempMasterProviderType, (providerName) => {
      tempProviderName.push(...providerName.providers.values);
    });
    let tempInGroupingProviderName = tempProviderName.filter((item: any) => {
      return !dayFilter["provider_name"].includes(item);
    });
    tempInGroupingProviderName = [...dayFilter["provider_name"], ...tempInGroupingProviderName];
    tempProviderName = tempInGroupingProviderName;
    setProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });
    setCopyProviderNameObject({
      label: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.label : "",
      column: tempMasterProviderType.length > 0 ? tempMasterProviderType[0].providers.column : "",
      options: tempProviderName,
      selectedOffice: [],
    });

    setCopyTepDayFilter({ provider_type: [], provider_name: [] });

    //////////////////////////////////////////////////////////////////////////////////////
    // toggleDrawer();
  };

  const drawerView = () => {
    return (
      //officeList
      <FilterForDayCalender
        isloadingFilter={isloadingFilter}
        officeObject={officeObject}
        copyOfficeObject={copyOfficeObject}
        onOfficeSelection={onOfficeSelection}
        providerTypeObject={providerTypeObject}
        copyProviderTypeObject={copyProviderTypeObject}
        onProviderTypeSelection={onProviderTypeSelection}
        providerNameObject={providerNameObject}
        copyProviderNameObject={copyProviderNameObject}
        onProviderNameSelection={onProviderNameSelection}
        copyTempDayFilter={copyTempDayFilter}
        onSearchOptionsOffice={onSearchOptionsOffice}
        onSearchOptionsProviderType={onSearchOptionsProviderType}
        onSearchOptionsProviderName={onSearchOptionsProviderName}
        activePanels={selectedActiveDayFilters}
        onCollapseChange={onCollapseChange}
      />
    );
  };

  //////////

  return (
    <>
      <Badge dot={isFilterDayApplied} offset={[-12, 12]}>
        <span
          className={`btn-icon icon-filter clr-n125 ${isFilterDayApplied ? "tableFilterApplied" : ""} `}
          style={{ height: "42px" }}
          onClick={(e) => {
            e.stopPropagation();
            toggleDrawerHandler(!isOpenDrawer);
          }}
        />
      </Badge>
      <Drawer
        destroyOnClose={true}
        title={layerViews[0].label}
        placement="right"
        closable={false}
        onClose={onCloseConfigDrawer}
        visible={isOpenDrawer}
        key="right"
        width={layerViews[0].width}
        bodyStyle={{ padding: layerViews[0].padding }}
        className={`membersListingDrawer ${layerViews[0].className} calender_day__filter`}
        footer={drawerFooter()}
        extra={drawerHeader()}
      >
        {drawerView()}
      </Drawer>
    </>
  );
};

export default DayFilter;
